import ToolCalcLinkCard from './components/ToolCalcLinkCard';
import styles from './toolsCalculatorsSummaryLinks.module.scss';

type Link = {
  image?: string;
  href: string;
  header: string;
  description: string;
};

type ToolsCalculatorsSummaryLinksProps = {
  header: string;
  links: Link[];
  headingLevel?: 'h1' | 'h2';
};

export default function ToolsCalculatorsSummaryLinks({
  header,
  links,
  headingLevel = 'h2'
}: ToolsCalculatorsSummaryLinksProps) {
  const HeadingTag = headingLevel;

  return (
    <div className={styles.toolsCalculatorsSummaryLinks}>
      <HeadingTag className={styles.header}>{header}</HeadingTag>
      <div className={styles.linksGrid}>
        {links.map((link) => (
          <ToolCalcLinkCard
            key={link.href}
            image={link.image}
            href={link.href}
            header={link.header}
            description={link.description}
          />
        ))}
      </div>
    </div>
  );
}
